var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Alert } from "@brushfire/ui";
import { useContext, useRef } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { putAttendeeGift } from "../../../data/api";
import { useDispatch } from "react-redux";
import { handleErrors } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import * as Yup from "yup";
import { getLocal, LOCAL_STORAGE_KEYS } from "../../../data/localStorageHelpers";
import ReCAPTCHA from "react-google-recaptcha";
import { Error } from "@brushfire/ui";
import { AppFormContext } from "../../../App";
import moment from "moment";
import useFormatters from "../../../hooks/useFormatters";
import { FormattedDate, FormattedTime } from "react-intl";
var MyAttendeeGift = function (_a) {
    var _b, _c;
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, kiosk = _a.kiosk, upsertAttendee = _a.upsertAttendee;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var recaptchaRef = useRef();
    var formikContext = useContext(AppFormContext).formikContext;
    var formatDate = useFormatters().formatDate;
    var onSubmit = function (values, formikHelpers, setGlobalError) { return __awaiter(void 0, void 0, void 0, function () {
        var token, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    formikHelpers.setSubmitting(false);
                    return [4 /*yield*/, recaptchaRef.current.executeAsync()];
                case 1:
                    token = _b.sent();
                    values.recaptchaResponse = token;
                    formikHelpers.setSubmitting(true);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    formikHelpers.setSubmitting(false);
                    recaptchaRef.current.reset();
                    formikHelpers.setFieldError("recaptchaResponse", "Recaptcha is required.");
                    return [2 /*return*/];
                case 3:
                    putAttendeeGift(attendee.id, values)
                        .then(function (_a) {
                        var data = _a.data;
                        upsertAttendee(data);
                        formikHelpers.setSubmitting(false);
                        history.push("./");
                    })
                        .catch(function (err) {
                        handleErrors(err, dispatch, formikContext, setGlobalError);
                    })
                        .finally(function () {
                        formikHelpers.setSubmitting(false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var initialValues = {
        fromName: (_b = getLocal(LOCAL_STORAGE_KEYS.NAME)) !== null && _b !== void 0 ? _b : "",
        fromEmail: (_c = getLocal(LOCAL_STORAGE_KEYS.EMAIL)) !== null && _c !== void 0 ? _c : "",
        recipientEmail: attendee.shareEmail,
        message: "",
        recaptchaResponse: "",
    };
    var formSchema = Yup.object().shape({
        fromName: Yup.string().required("Your Name is required"),
        fromEmail: Yup.string()
            .email("Your Email is required")
            .required("Your Email is required"),
        recipientEmail: Yup.string()
            .email("Gift Recipient's Email is required")
            .required("Gift Recipient's Email is required"),
        message: Yup.string().required("Message is required"),
    });
    // if (attendee.changesAreBlocked && path === Constants.Routes.myAttendeeGift) {
    // 	history.push(
    // 		Constants.Routes.myAttendee
    // 			.replace(":clientKey", eventData.clientKey)
    // 			.replace(":urlKey", eventData.urlKey)
    // 			.replace(":eventNumber", eventData.eventNumber.toString())
    // 			.replace(Constants.Regex.guid, "")
    // 			.replace(":attendeeId", attendee.id)
    // 	);
    // }
    var isCurrentYear = function (value) {
        return value ? new Date(value).getFullYear() === new Date().getFullYear() : false;
    };
    return (_jsxs(_Fragment, { children: [attendee.changesAreBlocked && attendee.changesAreBlockedAfter && (_jsxs(Alert, __assign({ purpose: "warning" }, { children: [(eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "TIX" ? "Tickets" : "Registrations", " of this type cannot be gifted after ", _jsx(FormattedDate, { value: moment.utc(attendee.changesAreBlockedAfter).toDate(), year: "numeric", month: "long", day: "numeric", weekday: "long" }), " ", _jsx(FormattedTime, { value: moment.utc(attendee.changesAreBlockedAfter).toDate(), hour12: true }), "."] }))), _jsxs("p", { children: ["Gift this ", eventData.verbiage === "Tickets" ? "ticket" : "registration", " by entering email for the person you want to receive your gifted ", eventData.verbiage === "Tickets" ? "ticket" : "registration", "!"] }), _jsx(Form, __assign({ initialValues: initialValues, validationSchema: formSchema, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: "Send Gift",
                    disableCartButton: attendee.changesAreBlocked,
                }, useUnsavedPrompt: false }, { children: function (_a) {
                    var formikContext = _a.formikContext;
                    return (_jsx(_Fragment, { children: _jsx(WidgetFieldset, { children: _jsxs("div", __assign({ className: "pos-relative" }, { children: [_jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.myAttendeeGift], formikContext: formikContext, active: true, initialValues: {}, focusDelay: 500 }), _jsx(Form.Field, { name: "fromName", id: "fromName", label: "Your Name", autoComplete: !kiosk }), _jsx(Form.Field, { name: "fromEmail", id: "fromEmail", label: "Your Email", type: "email", autoComplete: !kiosk }), _jsx(Form.Field, { name: "recipientEmail", id: "recipientEmail", label: "Gift Recipient's Email", type: "email", autoComplete: !kiosk }), _jsx(Form.Field, { component: Form.Input.TextArea, name: "message", id: "message", label: "Message", autoComplete: !kiosk }), _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: Constants.RecaptchaSiteKey, onChange: function (value) {
                                            formikContext.setFieldValue("recaptchaResponse", value);
                                        }, size: "invisible" }), _jsxs("p", __assign({ className: "mini" }, { children: ["This site is protected by reCAPTCHA and the Google", " ", _jsx("a", __assign({ href: "https://policies.google.com/privacy" }, { children: "Privacy Policy" })), " and", " ", _jsx("a", __assign({ href: "https://policies.google.com/terms" }, { children: "Terms of Service" })), " apply."] })), formikContext.errors.recaptchaResponse && formikContext.submitCount > 0 && (_jsx(Error, { children: formikContext.errors.recaptchaResponse }))] })) }) }));
                } }))] }));
};
export default MyAttendeeGift;
